import ImpactPill, { CompareMode } from "@/components/Impact/ImpactPill";
import { multiplyImpactWithFactor } from "@/pages/facilities/detail/Utilities/utils";
import { Select } from "antd";
import _ from "lodash";
import {
  BomItemCompare,
  useCompareProductScenarios,
  useGetProductScenarios,
} from "../../../useProducts";
import styles from "../ProductScenarios.module.scss";
import BillOfMaterialsCompareTable from "./BillOfMaterialsCompareTable";
import ProductScenarioCompareSkeleton from "./ProductScenarioCompareSkeleton";

function multiplyBom(bom: BomItemCompare, multiplier?: number) {
  if (!multiplier) return bom;

  const newBom: BomItemCompare = _.clone(bom);
  newBom.total_mass *= multiplier;
  newBom.impact = multiplyImpactWithFactor(newBom.impact, multiplier) || newBom.impact;
  newBom.children = bom.children.map((child) => {
    return multiplyBom(child, multiplier);
  });

  return newBom;
}

export default function ProductScenarioCompare({
  scenarioId,
  productId,
  onScenarioChange,
  compareScenarioId,
  multiplier,
  displayMode,
}: {
  scenarioId?: number;
  compareScenarioId?: number;
  onScenarioChange: (scenarioId: number) => void;
  productId: number;
  multiplier?: number;
  displayMode: CompareMode;
}) {
  const compareScenarioBom = useCompareProductScenarios({
    productId,
    scenarioId: scenarioId || 0,
    compareScenarioId: compareScenarioId || 0,
    enabled: !!(scenarioId !== undefined && compareScenarioId !== undefined),
  });

  const productScenarios = useGetProductScenarios({ productId });
  const scenario = productScenarios.data?.scenarios.find((x) => x.id === scenarioId);
  const compareScenario = productScenarios.data?.scenarios.find((x) => x.id === compareScenarioId);

  if (productScenarios.isLoading) return <ProductScenarioCompareSkeleton />;

  return (
    <div className={`${styles.scenario} ${styles.open}`}>
      <div className={styles.header}>
        <span className={styles.name}>
          <Select
            style={{ minWidth: "250px" }}
            options={productScenarios.data?.scenarios.map((x) => ({
              label: x.name,
              value: x.id,
              disabled: x.id === compareScenarioId,
            }))}
            value={scenarioId}
            onChange={onScenarioChange}
          />
        </span>
        <ImpactPill
          type="borderless"
          impact={multiplyImpactWithFactor(scenario?.impact, multiplier)}
          compareImpact={multiplyImpactWithFactor(compareScenario?.impact, multiplier)}
          compareMode={displayMode}
        />
      </div>
      <div className={styles.content}>
        <BillOfMaterialsCompareTable
          loading={compareScenarioBom.isLoading || compareScenarioBom.isFetching}
          data={
            compareScenarioBom.data?.scenario.bom
              ? multiplyBom(compareScenarioBom.data?.scenario.bom, multiplier)
              : undefined
          }
          noDataMessage="No bill of materials has been uploaded for this scenario yet."
        />
      </div>
    </div>
  );
}
